import { BudgetLegalEntityFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type TrainingsWizardData = {
  legalEntities: BudgetLegalEntityFragment[]
  legalEntityId?: number
  budgetId?: number
  success: boolean
  name: string
  description: string
  errors?: {
    [id: string]: string
  }
  effectiveFrom: string
  effectiveUntil?: string
  amountCents: string
  currency: string
  // Allocation step - selected trainings and their classes
  selectedTrainingIds: number[]
  selectedTrainingClassIds: string[] // Training class IDs are strings from GraphQL
}

export type TrainingsWizardDataField = keyof TrainingsWizardData

const validateMandatory = (field: TrainingsWizardDataField, data: TrainingsWizardData) => {
  const value = data[field]
  if (Array.isArray(value)) {
    return !!value.length
  }
  return !!data[field]
}

const getInvalidMandatoryFields = (
  mandatoryFields: TrainingsWizardDataField[],
  data: TrainingsWizardData
) => {
  return mandatoryFields
    .map((field) => {
      return validateMandatory(field, data)
        ? null
        : { [field]: i18n.t('budgets.forms.errors.mandatory') }
    })
    .filter(Boolean)
}

export const validateMandatoryFields = (
  mandatoryFields: TrainingsWizardDataField[],
  data: TrainingsWizardData
) => {
  const invalidFields = getInvalidMandatoryFields(mandatoryFields, data)

  const getDataWithErrors = () => {
    const errors = Object.assign({}, ...invalidFields)

    return {
      ...data,
      errors
    }
  }
  return {
    dataWithErrors: getDataWithErrors(),
    invalidFields
  }
}
